import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../src/firebase';

interface UpgradePlanSelectorProps {
    currentPlan: string;
}

export const UpgradePlanSelector: React.FC<UpgradePlanSelectorProps> = ({ currentPlan }) => {
    const { t } = useTranslation();
    const [upgradeStatus, setUpgradeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
    const [upgradingPlan, setUpgradingPlan] = useState<'basic' | 'management' | null>(null);

    const handleUpgrade = async (plan: 'basic' | 'management') => {
        setUpgradingPlan(plan);
        setUpgradeStatus('loading');
        try {
            const createUpgradeRequest = httpsCallable(functions, 'createUpgradeRequest');
            const result = await createUpgradeRequest({ plan, billingCycle: 'monthly' });
            const { checkoutUrl } = (result.data || {}) as { checkoutUrl?: string };
            if (checkoutUrl) {
                window.open(checkoutUrl, '_blank');
            }
            setUpgradeStatus('success');
        } catch (error) {
            console.error("Upgrade request failed", error);
            setUpgradeStatus('error');
        }
    };

    if (currentPlan === 'management') return null;

    return (
        <div className="space-y-2 lg:space-y-3">
            {upgradeStatus === 'success' ? (
                <div className="w-full py-3 lg:py-3.5 px-3 bg-green-500/10 border border-green-500/30 text-green-400 text-sm lg:text-base font-bold rounded-xl text-center">
                    {t('subscription.upgrade_success', 'Ödeme sayfası yeni sekmede açıldı. Ödemenizi tamamladıktan sonra bu sayfayı yenileyebilirsiniz.')}
                </div>
            ) : (
                <>
                    {currentPlan !== 'basic' && (
                        <button
                            onClick={() => handleUpgrade('basic')}
                            disabled={upgradeStatus === 'loading'}
                            className="w-full py-3 lg:py-3.5 bg-primary hover:bg-primary-hover text-white text-sm lg:text-base font-bold rounded-xl shadow-lg shadow-primary/20 transition-all active:scale-95 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                            <span className="material-symbols-outlined text-[20px]">
                                {upgradeStatus === 'loading' && upgradingPlan === 'basic' ? 'progress_activity' : 'star'}
                            </span>
                            {t('subscription.upgrade_basic', 'Kahveinn Temel (₺749/ay)')}
                        </button>
                    )}

                    <button
                        onClick={() => handleUpgrade('management')}
                        disabled={upgradeStatus === 'loading'}
                        className="w-full py-3 lg:py-3.5 bg-primary hover:bg-primary-hover text-white text-sm lg:text-base font-bold rounded-xl shadow-lg shadow-primary/20 transition-all active:scale-95 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        <span className="material-symbols-outlined text-[20px]">
                            {upgradeStatus === 'loading' && upgradingPlan === 'management' ? 'progress_activity' : 'star'}
                        </span>
                        {t('subscription.upgrade_management', 'Kahveinn Yönetim (₺1.299/ay)')}
                    </button>

                    {upgradeStatus === 'error' && (
                        <p className="text-accent-red text-xs font-bold text-center">
                            {t('subscription.upgrade_error', 'Bir hata oluştu, lütfen tekrar deneyin')}
                        </p>
                    )}
                </>
            )}
        </div>
    );
};

export default UpgradePlanSelector;
